<template app>
<div class="blog-post">
     <v-flex xs12 class="caption pt-1 pb-1 text-xs-left"><b>{{filters.label ? filters.label :''}}</b></v-flex>
     <v-autocomplete attach
        :items="items"
        :item-text="filters.name"
        :item-value="filters.id"
        v-model="selected"
        persistent-hint
        cache-items
        color="blue"
        outline
        :chips="filters.id=='cust_num' && filters.company !='bst' ? false  :true"
        dense
        small
        clearable
        deletable-chips
        :multiple="filters.id=='cust_num' && filters.company !='bst' ? false : true"
        v-on:change ="triggerEvent"
      >
        </v-autocomplete> 
</div>
</template>

<script>
import DropDownModel from '@/api/service/DropDownService'

  export default {
   props: ["filters"],

 data () {
      return {
        selectedId:0,
        items:[]
      }
    },
    computed:{
      selected: {
        get:function() { return this.filters.default},
        set:function($val) { this.filters.default= $val}
      }
    },
    created: function() {
        console.log(this.filters,'bbbbbbbbbbb')
    DropDownModel.getList({"model":this.filters.source})
        .then(response => {
            this.setItems(response)                
        }).catch(error => {
            console.log(error)
    });
  },
  methods: {
      triggerEvent($v,$event) {
          //console.log(selected)
          console.log($v)
          //console.log($event)
          var $json ={}
          $json[this.filters.id]=$v;
          this.$emit('change',$json)

      },
      setItems(items) {
          var $i=0;
          var $exclude ={}
          $exclude[this.filters.id]='!'
          $exclude[this.filters.name]='Exclude'
          this.items.push($exclude)
          for($i=0;$i<items.length;$i++) {
          this.items.push(items[$i]) 
      }
      }
      }
  }
</script>